import {EVENT_COMPUTE_LAYOUT, EventManagerInstance} from "~/cabinet/ts/Constant";
import {onUpdated} from "vue";

export function useLayoutUpdate() {
    onUpdated(() => {
        EventManagerInstance.emit(EVENT_COMPUTE_LAYOUT);
    })
}